import { ManagerVerificationStatusEnumType } from "../api/enums";
import { ManagerModel } from "../api/models";

export const isManagerVerified = (manager: ManagerModel) => {
  return (
    manager.verificationStatus === ManagerVerificationStatusEnumType.Verified
  );
};
